import prompt from '../libs/inquirer'
import { checkAll } from '../core/checkDeploy'

const testAll = (program) => {
  program
    .command('test')
    .description('Check event payload')
    .action(() => checkAll())
}

export default {
  testAll,
}
